import { defaultTheme, RaThemeOptions } from "react-admin";
import { deepmerge } from '@mui/utils';

export const MyTheme: RaThemeOptions = deepmerge(defaultTheme, {
    components: {
        MuiCssBaseline: {
            styleOverrides: (theme: any) => `
              #root {
                max-width: 100vw;
                height:100vh;
                overflow-x: hidden;
              }
            `
        },

        RaTopToolbar: {
            styleOverrides: {
                root: {
                    alignItems: 'center', // 确保工具栏内容垂直居中
                },
            },
        },

        MuiTableCell: {
            styleOverrides: {
                root: {
                    textAlign: 'center',
                    justifyContent: 'center',

                },
            },
        },

        RaLayout: {
            styleOverrides: {
                root: {
                    minWidth: 'auto',
                    '.RaList-main': {
                        maxWidth: '100%',
                    },
                    '.RaDatagrid-tableWrapper': {
                        overflow: 'auto',
                    },
                    '.RaLayout-content': {
                        width: '100%',
                        overflow: 'hidden',
                    },
                },

            },
        },


        RaMenuItemLink: {
            styleOverrides: {
                root: {
                    // 默认状态样式
                    '&:hover': {
                    },
                    // 活动状态样式
                    '&.RaMenuItemLink-active': {
                        fontWeight: 'bold',
                        borderLeft: '3px solid #90caf9',
                        // 添加其他自定义样式
                    },
                },
            },
        },


    }
});

